import React from "react";
import './pr-typimg-title.scss';

import { connect } from 'remx';
import * as store from '../../../stores/slider/store';
import * as actions from '../../../stores/slider/actions';

class PrTypengTitleComponent extends React.Component {

    constructor() {
        super();
        this.state = {
            text: '',
            animated: false
        }
        this.component = React.createRef();
        this.top = null;
        this.left = null;
        this.scrollPosition = []; 
        this.values = store.getters.getValues();
        this.prevIndex = null;
        this.prevPosition = null;
        this.time = store.getters.getTime();
        this.scrolled = false;
    }

    componentDidUpdate() {
        if(this.prevIndex !== this.props.activeIndex) {
            this.left = this.component.current.getBoundingClientRect().left;
            this.calcPosition();
            this.calcShift();
            this.write();
        };
        if(JSON.stringify(this.props.titlePosition) !== this.prevPosition) {
            this.top = this.component.current.getBoundingClientRect().top + this.scrollWrapper.scrollTop;
            this.left = this.component.current.getBoundingClientRect().left;
            this.calcPosition();
            this.calcShift(); 
        }
        this.prevIndex = this.props.activeIndex;
        this.prevPosition = JSON.stringify(this.props.titlePosition);
    }

    componentDidMount(){
        this.scrollWrapper = document.querySelector('.home-page');
        this.top = this.component.current.getBoundingClientRect().top + this.scrollWrapper.scrollTop;
        this.left = this.component.current.getBoundingClientRect().left;

        this.resizeListener = () => {
            if(window.innerWidth < 568){
                this.setState({ animated: false});
            }
        }
        window.addEventListener('resize', this.resizeListener);

        this.left = this.component.current.getBoundingClientRect().left;
        actions.startInterval();
        this.scrollListener = () => {
            this.left = this.component.current.getBoundingClientRect().left;
            this.calcPosition();
            this.calcShift();
            if(window.innerWidth > 568){
                if(this.scrollWrapper.scrollTop > 0){
                    if(!this.state.animated) {
                        this.setState({animated: true});
                    }
                } else if(this.state.animated) {
                    this.setState({
                        animated: false
                    });
                }
            }
        };
        if(window.innerWidth > 568){
            if(this.scrollWrapper.scrollTop > 0) {
                this.setState({
                    animated: false
                });
            }
        }
        this.scrollWrapper.addEventListener('scroll', this.scrollListener);
    }

    calcPosition() {
        if(this.component.current) {
            this.component.current.style.setProperty('--animated-left', `${this.props.titlePosition[0] - this.left}px`);

            if(this.scrollWrapper.scrollTop > 0 && this.scrollWrapper.scrollTop < this.props.titlePosition[1] - this.top) {
                if(actions.intervalIsActive) {
                    actions.stopInterval();
                }
            } else {
                if(!actions.intervalIsActive) {
                    actions.startInterval();
                }
            }
        }
    }

    clear() {
        if(this.state.text) {
            this.setState({
                text: ''
            });
        }
        if(this.writeInterval) {
            clearInterval(this.writeInterval);
        }
    }

    write() {
        this.clear();
        if(!this.state.animated) {
            this.writeInterval = setInterval(() => {
                this.setState({
                    text: this.state.text + this.values[this.props.activeIndex].charAt(this.state.text.length)
                });
                if(this.state.text === this.values[this.props.activeIndex]) {
                    clearInterval(this.writeInterval);
                    this.writeInterval = null;
                }
            }, (this.time / 3) / this.values[this.props.activeIndex].length);
        } else {
            this.setState({
                text: this.values[this.props.activeIndex]
            });
        }
    }

    calcShift() {
        this.component.current.style.setProperty('--shift', this.component.current.querySelector('.placeholder > p > span').getBoundingClientRect().width+'px');
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.resizeListener);
        this.scrollWrapper.removeEventListener('scroll', this.scrollListener);
    }

    render(){
        return (
            <div className="wrapper" ref={this.component}>
                <div className="text placeholder">
                    <p>
                        {this.values[this.props.activeIndex].split(' ').map((v, i) => 
                            <span key={i}>{v}</span>
                        )}
                    </p>
                </div>
                <div className="text animated">
                    <p>
                        {this.state.text.split(' ').map((v, i) => 
                            <span key={i} className="word">{v}</span>
                        )}
                        <span className="dotts"></span>
                        <span className="dotts"></span>
                    </p>
                </div>
            </div>
        ); 
    }
}
function mapStateToProps() {
    return {
        activeIndex: store.getters.getActiveIndex(),
        titlePosition: store.getters.getTitlePosition()
    };
}

export default connect(mapStateToProps)(PrTypengTitleComponent);